export default {"src":"/fly/_next/static/media/info.41904464.svg","height":23,"width":23,"blurWidth":0,"blurHeight":0};